import { AccordionDetails, AccordionSummary, Grid2, Stack, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { formatCurrency } from 'utils';
import { formatCamelCaseToText } from 'formatters';
import { Nullable } from 'global';
import { DealBuilderQuote } from '../../../../api';
import { FlatAccordion } from './FlatAccordion';
import { PriceField } from './PriceField';

interface Props {
  quote: Nullable<DealBuilderQuote>;
}

export const AdditionalChargesSection = ({ quote }: Props) => {
  const fees = quote?.fees ?? [];

  return (
    <FlatAccordion disableGutters>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" flex={1} pr={1}>
          <Typography fontWeight={500}>Additional Charges</Typography>
          <Typography variant="body2" color="text.secondary" fontWeight={400}>
            {formatCurrency(quote?.feesTotal ?? 0, true)}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Grid2 container spacing={2}>
          {fees.length === 0 && (
            <Grid2 size={12}>
              <Typography color="text.secondary">No additional charges.</Typography>
            </Grid2>
          )}
          {fees.map((fee, index) => (
            <Grid2 key={`${fee.type}-${index}`} size={{ xs: 6, sm: 4 }}>
              <PriceField
                label={fee.description || formatCamelCaseToText(fee.type)}
                value={fee.price?.total ?? fee.amount}
              />
            </Grid2>
          ))}
        </Grid2>
      </AccordionDetails>
    </FlatAccordion>
  );
};
